import { Box, styled } from '@mui/material';

const EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';

/**
 * Fila de la bandeja. `read` y `expired` son props de presentación (se filtran para que no
 * lleguen al DOM): la no leída se eleva de superficie y marca el punto dorado; la caducada
 * se atenúa, porque sigue siendo consultable pero ya no compite por atención.
 *
 * La X de borrar se oculta hasta el hover SOLO en desktop: en táctil no hay hover y dejarla
 * escondida la volvía inalcanzable.
 */
const StyledNotificationRow = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'read' && prop !== 'expired'
})(({ theme, read, expired }) => ({
  alignItems: 'flex-start',
  backgroundColor: read ? theme.palette.surface.content : theme.palette.surface.raised,
  borderBottom: `1px solid ${theme.palette.hairline.main}`,
  columnGap: theme.spacing(0.5),
  display: 'flex',
  opacity: expired ? 0.6 : 1,
  padding: theme.spacing(1.5, 1, 1.5, 2.5),
  position: 'relative',
  transition: `background-color 200ms ${EASE}`,
  '&:last-of-type': {
    borderBottom: 0
  },
  '&:hover': {
    backgroundColor: theme.palette.surface.hover
  },
  '&::before': {
    backgroundColor: read ? 'transparent' : theme.palette.gold.main,
    borderRadius: '50%',
    content: '""',
    height: 6,
    left: 10,
    position: 'absolute',
    top: 22,
    width: 6
  },
  [theme.breakpoints.up('md')]: {
    '& .notification-row-delete': {
      opacity: 0,
      transition: `opacity 200ms ${EASE}`
    },
    '&:hover .notification-row-delete, & .notification-row-delete:focus-visible': {
      opacity: 1
    }
  }
}));

export default StyledNotificationRow;
